
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCreditCardGrid extends Serenity.EntityGrid<PsCreditCardRow, any> {
        protected getColumnsKey() { return PsCreditCardColumns.columnsKey; }
        protected getDialogType() { return PsCreditCardDialog; }
        protected getIdProperty() { return PsCreditCardRow.idProperty; }
        protected getInsertPermission() { return PsCreditCardRow.insertPermission; }
        protected getLocalTextPrefix() { return PsCreditCardRow.localTextPrefix; }
        protected getService() { return PsCreditCardService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}